// extracted by mini-css-extract-plugin
export default {"copy-icon":"overview-tab_copy-icon__rMRra","verify-icon":"overview-tab_verify-icon__ZSbjd","verified-icon":"overview-tab_verified-icon__WdfKH"};